/**
 * * 大健康门店系统 - 客户管理模块 业务层控制器
 * * path: /live/m/agent/storeCustomerManagement
 * * component: @/pages/agent/CusManage.vue
 * */
class StoreCustomerManagementController {
  static init() {
    // * 门店客户模块 - 样式风格修改
    const CusManageEl = document.getElementsByClassName('CusManage')
    if (CusManageEl && CusManageEl.length > 0) {
      for (const el of CusManageEl) {
        el.classList.add('vzan-store-cus-manage')
      }
    }
  }
}

export default StoreCustomerManagementController
